export default __webpack_public_path__ + "5461f186cb6bbe7919d3d118eee7da58.svg";